import { Directive, Input, OnInit, Optional, ViewContainerRef, Injectable, EventEmitter, Output, InjectionToken, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponentComponent } from '../base-component/base-component.component';
import { IFilterRouterParams, FiltersTypeEnum, ITypeFilter } from '../../filters/filters.enum';
import { filter, tap, first, take, delay, debounceTime, mergeMap, map } from 'rxjs/operators';
import { ComboComponent } from '../../filters/combo/combo.component';
import { TextFilterComponent } from '../../filters/text-filter/text-filter.component';
import { DateFilterComponent } from '../../filters/date-filter/date-filter/date-filter.component';
import { TranslocoService } from '@ngneat/transloco';
import { of } from 'rxjs';
import { TagsGenericComponent } from '../../../../../common-page-components/tags-generic/tags-generic.component';
export const TYPE_FILTER_TOKEN = new InjectionToken<ITypeFilter>('type-filter');

/**
 * Class for provide some common interface to all filters component.
 *
 * @export
 * @class RouterFilterReference
 */
@Injectable({
  providedIn: 'root'
})
export class RouterFilterReference extends BaseComponentComponent {
  @Output() changeData = new EventEmitter();
  constructor(@Inject(TYPE_FILTER_TOKEN) public type) {
    super();
  }
}

/**
 *
 *
 * @export
 * @class FiltersRouterDirective
 * @implements {OnInit}
 */
@Directive({
  selector: '[routerListenChange]',
  exportAs: 'routerListenChange'

})
export class FiltersRouterDirective extends BaseComponentComponent implements OnInit {

  /**
   * The router configuration for filter.
   *
   * @type {IFilterRouterParams}
   * @memberof FiltersRouterDirective
   */
  @Input() routerParamsData: IFilterRouterParams;

  constructor(
    private host: RouterFilterReference,
    private router: Router,
    private route: ActivatedRoute,
    protected translation_service: TranslocoService) {
    super();
  }

  /**
   * Method for get the name of the query that would appear in parameter.
   *
   * @param {*} data
   * @returns
   * @memberof FiltersRouterDirective
   */
  handleLogicForFilter(data) {
    switch (this.host.type) {
      case FiltersTypeEnum.ComboBox:
        if(data instanceof Array){
          return (data as Array<any>).map(value=> value[(this.host as ComboComponent).option_name_property])
        }
        return data ? data[(this.host as ComboComponent).option_name_property] : undefined;
      case FiltersTypeEnum.TextSearch:
        return data.length > 0 ? data : undefined;
      case FiltersTypeEnum.TagsFilter:
        return data && data.value ? data.value : undefined;
      case FiltersTypeEnum.DateFilter:
        const paramDate = data['value'] as Date;
        const date = new Date(paramDate.getFullYear(), paramDate.getMonth(), paramDate.getDate())
        const userTimezoneOffset = date.getTimezoneOffset() * 60000;
        return new Date(paramDate.getTime() - userTimezoneOffset).toISOString().slice(0, 10);
    }

    /*if(this.host instanceof TextFilterComponent){
      return data.length > 0 ? data : undefined;
    }*/
  }

  /**
   * Method for set the query parameter on init of component.
   *
   * @param {*} queryParameter The query parameter
   * @memberof FiltersRouterDirective
   */
  setDataInFilter(queryParameter) {
    let host: ComboComponent | TextFilterComponent | DateFilterComponent | TagsGenericComponent;
    if (queryParameter) {
      switch (this.host.type) {
        case FiltersTypeEnum.ComboBox:
          host = (this.host as ComboComponent)
          this.subscriptions.push(host.options_subject.pipe(
            filter((value) => value.length > 0),
            delay(this.routerParamsData.delay_time ? this.routerParamsData.delay_time : 0),
            this.routerParamsData.only_on_init === true ? first() : map(a=> a),
            tap(a => {
              host = (this.host as ComboComponent);
              let option;
              if(host.allConfig.selectMultiple){
                const findedOptions = Array.from(a).filter(option=>
                  queryParameter.findIndex(query => query ===this.translation_service.translate(option[(this.host as ComboComponent).option_name_property])) > -1
                );
                option = findedOptions;
              }else{
                option = a.find(option => this.translation_service.translate(option[(this.host as ComboComponent).option_name_property]) ===
                queryParameter);
              }
              if (option) {
                host = (this.host as ComboComponent)
                host.options_selected_subject.next(option);
              }
            }),
          ).subscribe());
          break;
        case FiltersTypeEnum.TagsFilter:
          host = (this.host as TagsGenericComponent);
          const findTag = host.tags.find(value => value.value === queryParameter);
          if(findTag && findTag.value){
            host.selectChange(findTag.value);
          }
          break;
        case FiltersTypeEnum.TextSearch:
          host = (this.host as TextFilterComponent);
          host.defaultTextValue = queryParameter;
          host.text_subject.next(queryParameter);
          break;
        case FiltersTypeEnum.DateFilter:
          host = (this.host as DateFilterComponent);
          //host.dateFormControl.setValue(queryParameter);
          const auxDate = new Date();
          const date = new Date(
            new Date(queryParameter).getTime() +
            auxDate.getTimezoneOffset() * 60000
          )
          host.date_subject.next({ value: date });
          break;
      }
    }

  }

  /**
   * Method for perform navigation when the data changes and update query parameters.
   *
   * @param {*} data
   * @memberof FiltersRouterDirective
   */
  performNavigation(data) {
    if (this.routerParamsData && this.routerParamsData.intercept_name) {
      of(debounceTime(this.routerParamsData.delay_time ? this.routerParamsData.delay_time : 0)).pipe(
        first(),
        tap(a=>{
          this.router.navigate([], { queryParamsHandling: 'merge',
          //skipLocationChange:true,
          queryParams: { [this.routerParamsData.intercept_name]: this.handleLogicForFilter(data) } })
        })
      ).subscribe();
    }
  }
  /**
   * {@inheritdoc}
   * @memberof FiltersRouterDirective
   */
  ngAfterViewInit(): void {
    if (this.routerParamsData && this.routerParamsData.intercept_name) {
      this.subscriptions.push(this.route.queryParams
        .pipe(
          first()
        )
        .subscribe(next => {
          this.setDataInFilter(next[this.routerParamsData.intercept_name])
        }));
    }
  }

  /**
   * {@inheritdoc}
   *
   * @memberof FiltersRouterDirective
   */
  ngOnInit() {
    super.ngOnInit();
  }

}
